import { useState } from 'react';
import { Outlet } from 'react-router';
import { Menu } from 'lucide-react';
import { usePartnerAuthStore } from '@/stores/partnerAuthStore';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetTitle } from '@/components/ui/sheet';
import { SidebarNav } from './SidebarNav';
import { SidebarUserMenu } from './SidebarUserMenu';

function SidebarBody({ role, onNavigate }: { role?: 'admin' | 'support'; onNavigate?: () => void }) {
  return (
    <div className="flex h-full flex-col bg-primary">
      <div className="flex h-16 shrink-0 items-center px-5">
        <img src="/logo.png" alt="KashRound Partners" className="w-32" />
      </div>
      <div className="flex-1 overflow-y-auto">
        <SidebarNav role={role} onNavigate={onNavigate} />
      </div>
      <SidebarUserMenu />
    </div>
  );
}

export function PartnerSidebarLayout() {
  const { partner } = usePartnerAuthStore();
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <aside className="fixed inset-y-0 left-0 z-40 hidden w-64 lg:block">
        <SidebarBody role={partner?.role} />
      </aside>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="w-64 border-none p-0">
          <SheetTitle className="sr-only">Navigation</SheetTitle>
          <SidebarBody role={partner?.role} onNavigate={() => setOpen(false)} />
        </SheetContent>
      </Sheet>

      <div className="lg:pl-64">
        <header className="sticky top-0 z-20 flex h-16 items-center gap-3 border-b border-border/60 bg-background/80 px-4 backdrop-blur lg:px-8">
          <Button variant="ghost" size="icon" className="lg:hidden" onClick={() => setOpen(true)} aria-label="Open menu">
            <Menu className="h-5 w-5" />
          </Button>
          <span className="font-display text-sm font-semibold text-muted-foreground">
            Partner Analytics Portal
          </span>
        </header>
        <main className="p-4 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
